/**
 * The conference/room lock state which identifies that the password was set by
 * the current/local participant/user.
 *
 * @type {string}
 */
export const LOCKED_LOCALLY = 'LOCKED_LOCALLY';
/**
 * The conference/room lock state which identifies that the password was set by
 * a remote participant/user.
 *
 * @type {string}
 */
export const LOCKED_REMOTELY = 'LOCKED_REMOTELY';
